import CommonApi from './../commonApi';
const registrationPlace = new CommonApi('registrationPlace', 'место регистрации');
export default {
  ...registrationPlace
};
